<template>
<div class="group_table_wrap">
  <el-table
      :data="groups"
      border
      style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        prop="group_id"
        label="id"
        min-width="30">
      </el-table-column>
      <el-table-column
        prop="name"
        label="角色">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          {{scope.row.status===1?'正常':'禁用'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
      label="操作"
      min-width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.group_id)">编辑</el-button>
            <el-button
            size="mini"
            @click="fnUpdataGroup(scope.row.group_id, scope.row.status)">
              {{scope.row.status===1?'禁用':'解禁'}}
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnDelGroup(scope.row.group_id)">删除</el-button>
        </template>
      </el-table-column>
   </el-table>

   <el-dialog title="修改用户组" :visible.sync="pop_show" append-to-body width="54%">
        <el-form :model="groupForm" status-icon :rules="rulesGroupForm" ref="groupForm" label-width="100px">
          <el-form-item label="角色：" prop="name">
            <el-input type="text" v-model="groupForm.name" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>

          <el-form-item label="页面权限点：" prop="permission_ids">
            <!-- 一级菜单 -->
            <div v-for='i in arr1' style="cursor: pointer;">
              <div @click='fn1(i.permission_id)'>
                <img v-if='i.permission_id==flag1' src="static/images/xia.png" style="height: 5px">
                <img v-else src="static/images/you.png" style="height: 10px">

                <input @click.stop type="checkbox" :value='i.permission_id' v-model='checkedArr1'>
                <span>&emsp;{{i.name}}</span>
              </div>
              <div v-if='i.permission_id==flag1'>
                <!-- 二级菜单 -->
                <div v-for='j in arr2' style="padding-left: 60px">
                  <div @click='fn2(j.permission_id)'>
                    <img v-if='j.permission_id==flag2' src="static/images/xia.png" style="height: 5px">
                    <img v-else src="static/images/you.png" style="height: 10px">

                    <input @click.stop type="checkbox" :value='j.permission_id' v-model='checkedArr1'>
                    <span>&emsp;{{j.name}}</span>
                  </div>
                  <div v-if='j.permission_id==flag2'>
                    <!-- 权限点 -->
                    <div v-for='k in arr3' style="padding-left: 60px">
                      <div>
                        <input @click.stop type="checkbox" :value='i.permission_id' v-model='checkedArr1'>
                        <span>&emsp;{{k.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="是否启用：" prop="status">
            <template>
              <el-radio-group v-model="groupForm.status">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="text" v-model="groupForm.remark" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="pop_show=false">取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'GroupTable',
  props:['groups'],
  data () {
    var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('组名不能为空'));
        } else {
          callback()
        }
    };
    return {
      pop_show:false,
      checkedArr1: [],
      arr1: [],
      arr2: [],
      arr3: [],
      flag1: '',
      flag2: '',
      edit_id:0,
      groupForm:{
        name:'',
        status:'',
        remark:'',
      },
      rulesGroupForm:{
        name: [
            { validator:validateName, trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
  	fnGetPowerList(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: 0,
          type: 0
        }
      })
      .then(dat=>{
          this.arr1 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnPopShow(id){
       this.pop_show = true;
       this.edit_id = id;
       let token = localStorage.token;
       this.axios.get(cons.apis + '/v1_0/groups/'+ id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
         this.groupForm = dat.data.data;
         // this.groupForm.listval = dat.data.permissions;
         for(var i=0;i<this.groupForm.permission_tree.length;i++){
          if(this.groupForm.permission_tree[i].checked === 1){
            this.checkedArr1.push(this.groupForm.permission_tree[i].permission_id)
          }
          for(var j=0;j<this.groupForm.permission_tree[i].children.length;j++){
            if(this.groupForm.permission_tree[i].children[j].checked === 1){
              this.checkedArr1.push(this.groupForm.permission_tree[i].children[j].permission_id)
            }
          }
         }
      }).catch(err=>{
         console.log(err.response);
      });
    },
    submitForm(){
      let token = localStorage.token;
      this.axios.put(cons.apis + '/v1_0/groups/'+this.edit_id, {
              "remark": this.groupForm.remark, // 备注
              "name": this.groupForm.name,  // 权限组名称
              "status": this.groupForm.status,  // 状态(1启用 0禁用)
              "permission_ids":this.checkedArr1 // 权限id列表
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '修改组成功!'
          });
          this.pop_show = false;
          this.resetForm('groupForm');
          this.$emit('fnResetTable');
        }).catch(err=>{
          console.log(err.response);
        })
    },
    fnDelGroup(id){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('此操作将删除该组, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.delete(cons.apis + '/v1_0/groups/'+this.edit_id,{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'组未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    fnUpdataGroup(id, sta){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('是否确定该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.put(cons.apis + '/v1_0/groups/'+this.edit_id,{
              "status": sta===1?0:1,  // 状态(1启用 0禁用)
            },{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '禁用成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'角色未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    fn1(pid){
      this.flag1 = this.flag1===pid?'':pid
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: pid,
          type: 0
        }
      })
      .then(dat=>{
          this.arr2 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    },
    fn2(pid){
      this.flag2 = this.flag2===pid?'':pid
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: pid,
          type: 1
        }
      })
      .then(dat=>{
          this.arr3 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    }
  },
  mounted(){
    this.fnGetPowerList();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widget/RoleTable.vue